module.exports = __webpack_public_path__ + "static/img/landed.d573301e.png";